import { Box, Tabs, Tab, Divider, Button } from "@mui/material";
import { Sidebar } from "./Sidebar";
import { useState } from "react";
import { useUser } from "./UserProvider";
import { req } from "./ServerUtils";

export function Settings() {
    const [selectedTab, setSelectedTab] = useState("extension");
    
    return (
        <Box display="flex" height="100vh">
            <Sidebar selected="settings" />
            <div style={{
                padding: 20,
                flexGrow: 1,
            }}>
                <div style={{
                    borderBottom: "solid 1px #f5f5f5",
                    width: "100%",
                }}>
                    <Tabs value={selectedTab} onChange={(e, value) => setSelectedTab(value)}>
                        <Tab value="extension" label="Extension" />
                        <Tab value="billing" label="Billing" />
                    </Tabs>
                </div>
                <div style={{
                    padding: 20,
                }}>
                    {selectedTab === "extension" && <ExtensionSettings />}
                    {selectedTab === "billing" && <div>Billing</div>}
                </div>
            </div>
        </Box>
    )
}
function ExtensionSettings() {
    const { userInfo } = useUser();
    
    if (!userInfo?.linkedin_urn) {
        return (
            <div>
                <h3>Step 1: Install the extension</h3>
                <div>
                    <Button variant="outlined">Install MakeMyBrand Chrome Extension</Button> 
                    {/* https://chromewebstore.google.com/detail/linkedin-carousel-generat/epehcmcofkloohohfibbjdghiefhegfg?authuser=1&hl=en-GB */}
                </div>
                <h3>Step 2: Connect your LinkedIn account</h3>
                <div>Visit your profile on linkedin.com to connect your LinkedIn account to MakeMyBrand.</div>
            </div>
        )
    }
    function disconnect() {
        req('/linkedin/unlink-user',"POST").then((res) => {
            console.log(res);
            if (res) {
                window.location.reload();
            }
        })
    }
    return (
        <div>
            <div>
                You've connected your LinkedIn account.
            </div>
            <div style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid rgb(98, 98, 98)",
                padding: 20,
                borderRadius: 10,

                marginTop: 20,
                width: 500,
                gap: 10
            }}>
                <img style={{
                    width: 100,
                    height: 100,
                    borderRadius: 50,
                }} src={userInfo.info.profile_pic_cropped} alt="Profile" />
                <div style={{
                    fontSize: "1.2rem",
                    fontWeight: "bold",
                }}>{userInfo.info.name}</div>
                <div>{userInfo.info.description}</div>
                <div><a href='#' onClick={disconnect}>Disconnect LinkedIn</a></div>
            
            </div>
        </div>
    )
}
